export default {
  // proxy: "https://everybody-hates-cors.herokuapp.com/",
  proxy: "",
  currentEnv: process.env.VUE_APP_BUILDENV,
  mock: false,
  verbose: false,
  saveWebsocket: false,
  googleMapsApiKey: "",
  environment: {
    dev: {
      azure: {

      },
      api: {
        hostname: "https://apim-irinox-dev.azure-api.net",
        subscriptionkey: "edb42701676e45308b48980c231063f9",
        clientId: "61a98205-03f6-4525-beb3-4a329dbb6490",
        clientSecret: "UIc7Q~UfC7F4ecMtIZM3g5LpK1i.zuk49U7pM",
        genericLoginUrl: "https://login.microsoftonline.com/d277a502-65b1-4ff0-9cdc-4999a919540b/oauth2/v2.0/token",
        personalLoginUrl: "https://irinoxidpdev.b2clogin.com/irinoxidpdev.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_ROPC",
        websiteLoginUrl: "https://irinoxidpprod.b2clogin.com/irinoxidpprod.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_ROPC_IRINOX_PLATFORM",
        websiteClientId: "be2fb2db-e6b7-4720-b341-914c76c37527",
        base: {
          account: "/api/v1/account",
          account_v2: "/api/v2/account",
          appliance: "/api/v1/appliance",
          appliance_v2: "/api/v2/appliance",
          email: "/api/v1/mail",
          event: "/api/v1/event-hub-listener",
          analytics: "/api/v1/analytics",
          ai: "/api/v1/ai",
          energy: "/api/v1/energy",
          afterSales: "/api/v1/after-sales",
        }
      },
      socket: "wss://apim-irinox-dev.azure-api.net/ws/event-hub-listener",
      botSocket: "https://virtualassistant-ai.delightfulgrass-54b25c76.northeurope.azurecontainerapps.io",
      afterSalesAssets: "https://irinoxassetsdev.blob.core.windows.net/after-sales",
    },
    prod: {
      api: {
        hostname: "https://apim-irinox-prod.azure-api.net",
        subscriptionkey: "e4c417efb0124e9da54cdea4b38cdb57",
        clientId: "41f399eb-4269-437a-b6df-67e9be6e922f",
        clientSecret: "Fai8Q~VClFFnT-tLSwMBVnvVSMmarc5G3rR-RbcO",
        genericLoginUrl: "https://login.microsoftonline.com/1819a989-feab-4514-a4a0-54ef6be5b12b/oauth2/v2.0/token",
        personalLoginUrl: "https://irinoxidpprod.b2clogin.com/irinoxidpprod.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_ROPC",
        websiteLoginUrl: "https://irinoxidpprod.b2clogin.com/irinoxidpprod.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_ROPC_IRINOX_PLATFORM",
        websiteClientId: "be2fb2db-e6b7-4720-b341-914c76c37527",
        base: {
          account: "/api/v1/account",
          account_v2: "/api/v2/account",
          appliance: "/api/v1/appliance",
          appliance_v2: "/api/v2/appliance",
          email: "/api/v1/mail",
          event: "/api/v1/event-hub-listener",
          analytics: "/api/v1/analytics",
          ai: "/api/v1/ai",
          energy: "/api/v1/energy",
          afterSales: "/api/v1/after-sales",
        }
      },
      socket: "wss://apim-irinox-prod.azure-api.net/ws/event-hub-listener",
      botSocket: "",
      afterSalesAssets: "https://irinoxassetsprod.blob.core.windows.net/after-sales",
    }
  },
  env() {
    return this.environment[this.currentEnv];
  },
  headers(accesstoken) {
    return {
      'Ocp-Apim-Subscription-Key': this.env().api.subscriptionkey,
      'Authorization': `Bearer ${accesstoken}`
    };
  },
  url(type) {
    return this.env().api.hostname + this.env().api.base[type];
  },
  maintenanceEnabled() {
    // return this.currentEnv=='dev'/* || process.env.NODE_ENV === 'development'*/;
    return true;
  },
  afterSalesAssets(folder) {
    return this.env().afterSalesAssets + (folder ? '/' + folder : '') + '/';
  },
  afterSalesEnabled() {
    // return this.currentEnv=='dev';
    return true;
  },
  sparePartsEnabled() {
    // return this.currentEnv=='dev'/* || process.env.NODE_ENV === 'development'*/;
    // return false;
    return true;
  },
  isChatbotEnabled(chatbot) {
    // return this.currentEnv=='dev';
    return chatbot;
  },
  isFreviEnabled(appliance) {
    // return appliance.gamma === 'CP';
    return appliance.serialNumber == '220500732M';

  }
}
